import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['plansFlow', 'addonsFlow', 'selectedPlanName', 'membershipInput', 'totalPrice'];

    connect() {
        this.countdownInterval = null;
        this.basePrice = 0;
        this.startCountdowns();
    }

    disconnect() {
        this.stopCountdowns();
    }

    /**
     * City dropdown options are links to city landing pages.
     */
    cityChanged(event) {
        const link = event.currentTarget.value;

        if (link) {
            window.location.href = link;
        }
    }

    /**
     * Plan selected: switch to the addons screen (no page reload) and show
     * only the addon group belonging to the selected membership.
     */
    selectPlan(event) {
        const button = event.currentTarget;
        const membershipId = button.dataset.membership;

        this.membershipInputTarget.value = membershipId;
        this.selectedPlanNameTarget.textContent = button.dataset.membershipTitle || '';
        this.basePrice = parseFloat(button.dataset.basePrice) || 0;

        this.resetAddons();

        this.addonsFlowTarget.querySelectorAll('[data-membership-addons]').forEach((group) => {
            const isSelected = group.dataset.membershipAddons === membershipId;

            group.style.display = isSelected ? '' : 'none';
            group.querySelectorAll('.ptv2-addon-input').forEach((input) => {
                input.disabled = !isSelected;
            });
        });

        this.switchFlow(true);
        this.updateTotal();
    }

    backToPlans() {
        this.switchFlow(false);
    }

    /**
     * Addon card +/✓ button toggles the underlying hidden checkbox (features[]).
     */
    toggleAddon(event) {
        const button = event.currentTarget;
        const input = button.closest('.ptv2-addon-card').querySelector('.ptv2-addon-input');
        const added = !input.checked;

        input.checked = added;
        button.classList.toggle('added', added);
        button.textContent = added ? '✓' : '+';

        this.updateTotal();
    }

    /**
     * Sticky bottom bar total: base plan price + selected addon prices.
     */
    updateTotal() {
        if (!this.hasTotalPriceTarget) {
            return;
        }

        let total = this.basePrice;

        this.addonsFlowTarget.querySelectorAll('.ptv2-addon-input:checked:not([disabled])').forEach((input) => {
            const button = input.closest('.ptv2-addon-card').querySelector('.ptv2-add-btn');

            total += parseFloat(button.dataset.price) || 0;
        });

        this.totalPriceTarget.textContent = total.toFixed(2) + ' €';
    }

    toggleTooltip(event) {
        event.currentTarget.classList.toggle('active');
    }

    /**
     * "Paslauga rasi" toggle: expand/collapse the club list inside the card.
     */
    toggleAddonClubs(event) {
        event.currentTarget.closest('.ptv2-addon-card').classList.toggle('clubs-open');
    }

    switchFlow(showAddons) {
        this.plansFlowTarget.classList.toggle('ptv2-flow--active', !showAddons);
        this.addonsFlowTarget.classList.toggle('ptv2-flow--active', showAddons);
        this.element.classList.toggle('ptv2-addons-open', showAddons);
        document.body.classList.toggle('ptv2-addons-open', showAddons);

        if (showAddons) {
            this.addonsFlowTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    resetAddons() {
        this.addonsFlowTarget.querySelectorAll('.ptv2-addon-input').forEach((input) => {
            input.checked = false;
            input.disabled = true;
        });

        this.addonsFlowTarget.querySelectorAll('.ptv2-add-btn').forEach((button) => {
            button.classList.remove('added');
            button.textContent = '+';
        });
    }

    startCountdowns() {
        this.stopCountdowns();

        this.countdownElements = this.element.querySelectorAll('.ptv2-countdown[data-countdown-end]');

        if (this.countdownElements.length === 0) {
            return;
        }

        this.updateCountdowns();
        this.countdownInterval = setInterval(() => this.updateCountdowns(), 1000);
    }

    stopCountdowns() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }
    }

    updateCountdowns() {
        const now = new Date();
        let expired = false;

        this.countdownElements.forEach((element) => {
            const remaining = Math.max(0, new Date(element.dataset.countdownEnd) - now);

            if (remaining === 0) {
                expired = true;
            }

            const hours = Math.floor(remaining / (1000 * 60 * 60));
            const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

            element.textContent = [hours, minutes, seconds]
                .map((value) => value.toString().padStart(2, '0'))
                .join(':');
        });

        // Countdown finished: reload, server renders the change-to membership
        if (expired) {
            this.stopCountdowns();
            window.location.reload();
        }
    }
}
